module.exports = __webpack_public_path__ + "static/media/logo-no-background.319e2ffa.png";